import React, { useEffect, useRef } from 'react';
import { trackGetStartedClick } from '../utils/analytics';
import './CTA_Enhanced.css';

const CTAEnhanced = () => {
  const ctaRef = useRef(null);

  // Redirect to testmindfrontend (app.qate.ai) for signup
  const saasUrl = process.env.REACT_APP_SAAS_URL || 'https://app.qate.ai';

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      {
        threshold: 0.3, // Increased from 0.1 for faster trigger
        rootMargin: '0px 0px -20px 0px' // Reduced from -50px
      }
    );

    const elements = ctaRef.current?.querySelectorAll('.fade-in');
    elements?.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const handleCTAClick = (e) => {
    e.preventDefault();
    trackGetStartedClick('cta-enhanced');
    window.gtag_report_conversion(`${saasUrl}/get-started`);
  };

  return (
    <section className="cta-section-enhanced" ref={ctaRef}>
      <div className="cta-container-enhanced">
        <div className="cta-gradient-wrapper fade-in">
          <div className="cta-gradient-card">
            <div className="cta-content">
              {/* Subtle sparkle decorations */}
              <div className="sparkle sparkle-1">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 0L14.59 9.41L24 12L14.59 14.59L12 24L9.41 14.59L0 12L9.41 9.41L12 0Z" />
                </svg>
              </div>
              <div className="sparkle sparkle-2">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 0L14.59 9.41L24 12L14.59 14.59L12 24L9.41 14.59L0 12L9.41 9.41L12 0Z" />
                </svg>
              </div>
              <div className="sparkle sparkle-3">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 0L14.59 9.41L24 12L14.59 14.59L12 24L9.41 14.59L0 12L9.41 9.41L12 0Z" />
                </svg>
              </div>

              <h2 className="cta-headline">
                Add sparkles to your test job
              </h2>
              <div className="cta-description">
                <p>
                  Transform tedious testing into something magical.<br />
                  <strong>Start for free</strong> and see the difference AI makes.
                </p>
              </div>
              <div className="cta-button-wrapper">
                <button
                  type="button"
                  className="cta-button-enhanced"
                  onClick={handleCTAClick}
                >
                  <span className="cta-button-text">Start for Free</span>
                </button>
                <button
                  type="button"
                  className="cta-button-enhanced cta-button-google"
                  onClick={handleCTAClick}
                >
                  <svg className="google-icon" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
                    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
                  </svg>
                  <span className="cta-button-text">Start free with Google</span>
                  <span className="cta-button-arrow">→</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTAEnhanced;